import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

export function ArtistHeader({ artistData, subscriptionTier }) {
  if (artistData.status === 'pending_payment') {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 flex gap-4">
        <AlertCircle className="text-yellow-600 flex-shrink-0 mt-1" size={20} />
        <div>
          <h3 className="font-semibold text-yellow-900 mb-1">Payment Pending</h3>
          <p className="text-sm text-yellow-800">
            Your subscription payment is being processed. You'll be able to upload content once payment is confirmed.
          </p>
        </div>
      </div>
    );
  }

  if (artistData.status !== 'active') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 flex gap-4">
        <AlertCircle className="text-red-600 flex-shrink-0 mt-1" size={20} />
        <div>
          <h3 className="font-semibold text-red-900 mb-1">Account Not Active</h3>
          <p className="text-sm text-red-800">
            Your artist account is not active. Please contact support for assistance.
          </p>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-green-600 to-blue-600 text-white p-6 rounded-xl"
    >
      <h2 className="text-2xl font-bold mb-2">{artistData.name}</h2>
      <p className="text-green-100 mb-4">{subscriptionTier.name} Plan {subscriptionTier.icon}</p>
      <div className="flex gap-6 text-sm">
        <div>
          <p className="text-purple-200">Status</p>
          <p className="font-semibold capitalize">{artistData.status}</p>
        </div>
        <div>
          <p className="text-purple-200">Member Since</p>
          <p className="font-semibold">
            {new Date(artistData.createdAt).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })}
          </p>
        </div>
      </div>
    </motion.div>
  );
}